var map = {
	"./blue/chiping.png": "./src/assets/image/blue/chiping.png",
	"./purple/chiping.png": "./src/assets/image/purple/chiping.png",
	"./red/chiping.png": "./src/assets/image/red/chiping.png",
	"./yellow/chiping.png": "./src/assets/image/yellow/chiping.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image sync recursive ^\\.\\/.*\\/chiping\\.png$";